//NPM Packages
import { React, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import SignaturePad from "react-signature-canvas";

//Utils
import { createApplicationPDF } from "../../utils/createPDF";

//Context
import MyContext from "../../context/MyContext";

//Styled Components
import CheckBoxButton from "../styles/CheckBoxButton";
import { Form } from "../styles/Form.styled";
import { Input } from "../styles/Input.styled";

//React Icons
import { CiCircleCheck } from "react-icons/ci";
import { CiCircleMore } from "react-icons/ci";
import { CiCircleRemove } from "react-icons/ci";
import Loader from "../styles/Loader.styled";
import LamininError from "../Shared/LamininError";
import LamininSent from "../Shared/LamininSent";
import Docs from "./Docs";

const FormHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: x-large;
`;

const FormSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormBody = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  border: 1px solid #bbb;
  border-radius: 3px;
  width: 100%;
`;

const Label = styled.label`
  padding: ${(props) => props.theme.space[1]};
  font-size: medium;
`;

const MessageCenter = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  text-align: center;
`;

const SignatureWrapper = styled.div`
  margin: ${(props) => props.theme.space[0]};
  border: 1px solid #bbb;
  border-radius: 3px;
  width: 300px;
  height: 150px;
`;

const SignatureButtonWrapper = styled.div`
  display: flex;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  align-items: center;
  justify-content: center;
`;

const SignaturePadWrapper = styled.div`
  display: flex;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Terms = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: medium;
`;

const ValidationMessage = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  color: red;
`;

const ValidationMessageCenter = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  color: red;
  text-align: center;
`;

const ValidationSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
  color: red;
`;

export default function Declartion(props) {
  const sigCanvas = useRef({});

  const {
    dev,
    data,
    setData,
    pdfDocData,
    setPdfDocData,
    headers,

    //Errors
    formError,
    setFormError,
    acceptTermsError,
    setAcceptTermsError,
    signatureError,
    setSignatureError,

    //Lead Forms
    declarationDataCaptured,
    setDeclarationDataCaptured,
    setAddressDataCaptured,
  } = useContext(MyContext);

  //Laminin State
  const [lamininSubmitted, setLamininSubmitted] = useState(false);
  const [lamininSent, setLamininSent] = useState(false);
  const [lamininError, setLamininError] = useState(false);

  //Documents State
  const [pdfDocSubmitted, setPdfDocSubmitted] = useState(false);
  const [pdfDocSent, setPdfDocSent] = useState(false);
  const [pdfDocError, setPdfDocError] = useState(false);

  //PDF Blob
  let pdfBlobRef = useRef(null);
  const [showDocs, setShowDocs] = useState(false);

  const back = () => setAddressDataCaptured(false);
  const clear = () => sigCanvas.current.clear();

  //Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //Submit PDF Doc
  useEffect(() => {
    if (
      pdfDocData.pdfName !== "" &&
      pdfDocData.pdfBase64 !== null &&
      !pdfDocSubmitted
    ) {
      setPdfDocSubmitted(true);

      const customPdfDocData = {
        leadId: data.leadId,
        pdfName: pdfDocData.pdfName,
        pdfBase64: pdfDocData.pdfBase64,
      };

      axios
        .post(
          dev ? "http://localhost:5000/api/docs" : "api/docs",
          customPdfDocData,
          {
            headers: headers,
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              console.log("Laminin Response OK: " + response.status);
              setPdfDocSent(true);
            } else {
              console.log("Laminin Response Not OK: " + response.status);
              setPdfDocError(true);
            }
          },
          (error) => {
            console.log("Laminin Response Error: " + error);
            setPdfDocError(true);
          }
        );
    }
  }, [
    dev,
    data,
    pdfDocData,
    pdfDocSubmitted,
    headers,
    setPdfDocError,
    setPdfDocSent,
  ]);

  const downloadPDF = () => {
    if (!pdfBlobRef.current) {
      alert("No PDF available for download");
      return;
    }

    // Create download link from Blob
    const url = URL.createObjectURL(pdfBlobRef.current);
    const link = document.createElement("a");
    link.href = url;
    link.download = pdfDocData.pdfName || "Unknown.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const uploadDocs = () => {
    setShowDocs(!showDocs);
  };

  const handleInfoChange = (event) => {
    const { name, value } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const handleCheckboxInfoChange = (event) => {
    const { name, checked } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: checked ? "Yes" : "No",
      };
    });
  };

  const createPdf = () => {
    // Get signature image
    const sigImage = sigCanvas.current.toDataURL("image/png", 0.5);

    // Generate PDF using utility
    const pdfResult = createApplicationPDF({
      data: data,
      logoPath: props.logoPath,
      signatureImage: sigImage,
      formName: `${props.name} - ${props.formName}`,
    });

    // Store blob reference
    pdfBlobRef.current = pdfResult.blob;

    // Save base64 for API submission
    saveFile(`${props.name} ${props.formName}.pdf`, pdfResult.base64);

    // Update lead
    updateLead();
  };

  const saveFile = (filename, base64) => {
    setPdfDocData((prevValue) => {
      return {
        ...prevValue,
        pdfName: filename,
        pdfBase64: base64,
      };
    });
  };

  const updateLead = () => {
    setLamininSubmitted(true);
    axios
      .post(dev ? "http://localhost:5000/api/update" : "api/update", data, {
        headers: headers,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Laminin Response OK: " + response.status);
            setLamininSent(true);
            setDeclarationDataCaptured(true);
          } else {
            console.log("Laminin Response Not OK: " + response.status);
            setLamininError(true);
          }
        },
        (error) => {
          console.log("Laminin Response Error: " + error);
          setLamininError(true);
        }
      );
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    let isValid = true;

    // Accept Terms and Conditions validation
    if (data.acceptTermsAndConditions !== "Yes") {
      setAcceptTermsError("Please accept the Terms and Conditions to continue");
      isValid = false;
    } else {
      setAcceptTermsError("");
      setFormError("");
    }

    //Signature validation
    if (
      sigCanvas.current.isEmpty() &&
      data.acceptTermsAndConditions === "Yes"
    ) {
      setSignatureError(
        "Please sign in the area provided and click on Submit once done"
      );
      isValid = false;
    } else {
      setSignatureError("");
      setFormError("");
    }

    if (!isValid) {
      setFormError(
        "Note: There are errors on this form. Please correct and click on Next to continue."
      );
      window.scrollTo(0, 0);
    }

    if (isValid) {
      setDeclarationDataCaptured(true);
      createPdf();
    }
  };

  return (
    <div>
      {!declarationDataCaptured && (
        <Form onSubmit={handleFormSubmit}>
          <FormHeading>
            {props.name} - {props.formName}
          </FormHeading>
          {formError && (
            <ValidationSubHeading>{formError}</ValidationSubHeading>
          )}
          <FormSubHeading>Declaration</FormSubHeading>
          <FormBody>
            <ItemWrapper>
              <Label>Terms and Conditions</Label>
              <Terms>{data.termsAndConditions}</Terms>
            </ItemWrapper>
            <ItemWrapper>
              <CheckBoxButton
                name="acceptTermsAndConditions"
                id="acceptTermsAndConditions"
                onChange={handleCheckboxInfoChange}
                value="Yes"
                checked={data.acceptTermsAndConditions === "Yes"}
                label="I accept the Terms and Conditions"
              />
              {acceptTermsError && (
                <ValidationMessage>{acceptTermsError}</ValidationMessage>
              )}
              <Input
                type="text"
                name="signedLocation"
                onChange={handleInfoChange}
                placeholder="Signed Location (Required)"
                required={true}
                value={data.signedLocation}
                width="100%"
              />
            </ItemWrapper>
            <SignaturePadWrapper>
              <SignatureWrapper>
                <SignaturePad
                  clearSignature={clear}
                  ref={sigCanvas}
                  canvasProps={{
                    width: 300,
                    height: 150,
                    className: "signature",
                    onMouseDown: () => {
                      if ("activeElement" in document)
                        document.activeElement.blur();
                    },
                    onTouchStart: () => {
                      if ("activeElement" in document)
                        document.activeElement.blur();
                    },
                  }}
                />
              </SignatureWrapper>
              {!signatureError && <MessageCenter>Signature</MessageCenter>}
              {signatureError && (
                <ValidationMessageCenter>
                  {signatureError}
                </ValidationMessageCenter>
              )}
            </SignaturePadWrapper>
            <SignatureButtonWrapper>
              <button
                onClick={back}
                className="btn btn-outline-dark btn-md"
                type="button"
                style={{ margin: "0 2px" }}
                disabled={formError}
              >
                Back
              </button>
              <button
                className="btn btn-outline-dark btn-md"
                type="button"
                style={{ margin: "0 2px" }}
                onClick={clear}
              >
                Clear
              </button>
              <button
                className="btn btn-dark btn-md"
                type="submit"
                style={{ margin: "0 2px" }}
              >
                Submit
              </button>
            </SignatureButtonWrapper>
          </FormBody>
        </Form>
      )}

      {declarationDataCaptured && (
        <Form>
          <FormHeading>
            {props.name} - {props.formName}
          </FormHeading>

          {lamininSubmitted && !(lamininSent || lamininError) && <Loader />}
          {lamininError && <LamininError phone={props.phone} />}
          {lamininSent && <LamininSent leadId={data.leadId} />}

          {pdfDocSubmitted && !(pdfDocSent || pdfDocError) && (
            <FormSubHeading>
              <CiCircleMore /> Submitting your Application Form, please stand
              by...
            </FormSubHeading>
          )}

          {pdfDocSent && (
            <FormSubHeading>
              <CiCircleCheck style={{ color: "green" }} /> Application Form
              successfully submitted.
            </FormSubHeading>
          )}

          {pdfDocError && (
            <FormSubHeading>
              <CiCircleRemove style={{ color: "red" }} /> Application Form not
              received. Please contact us on {props.phone}.
            </FormSubHeading>
          )}

          {lamininSent && pdfDocSent && (
            <FormBody>
              <button
                className="btn btn-dark btn-md"
                type="button"
                style={{ margin: "0 2px" }}
                onClick={downloadPDF}
                disabled={!pdfBlobRef.current}
              >
                Download Application
              </button>
              <button
                className="btn btn-dark btn-md"
                type="button"
                style={{ margin: "0 2px" }}
                onClick={uploadDocs}
              >
                Upload Documents
              </button>
            </FormBody>
          )}

          {showDocs && (
            <Docs
              name="Laminin"
              formName="Demo Form"
              phone="0100 546 546"
            />
          )}
        </Form>
      )}
    </div>
  );
}
